<template>
  <avatar-widget
    :avatar-src="profile ? profile.avatar : null"
    :placeholder="$vuetify.icons.values.user"
    :onUpdate="onNewAvatar"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '../store'
import { AvatarWidget } from '../../components'

export default {
  name: 'MeAvatar',
  components: {
    AvatarWidget
  },
  computed: {
    ...mapState(NAMESPACE, ['profile'])
  },
  methods: {
    ...mapActions(NAMESPACE, ['uploadAvatar']),
    onNewAvatar(payload) {
      return this.uploadAvatar(payload)
    }
  }
}
</script>
